
import React, { Component } from 'react';

// Externals
import compose from 'recompose/compose';
// Material helpers
import { withStyles } from '@material-ui/core/styles';

import { withRouter } from 'react-router-dom';

// Shared components
import PortletHeader from 'components/PortletHeader';
import PortletToolbar from 'components/PortletToolbar';
// Material components
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import CloseIcon from '@material-ui/icons/Close';
import IconButton from '@material-ui/core/IconButton';
// Component styles
import styles from './styles';
import CircularProgress from '@material-ui/core/CircularProgress';
import BaseDataElements from './BaseDataElements'
import Period from '../../../../helpers/PeriodScreenshot';
import Grid from '@material-ui/core/Grid';
import Popover from '@material-ui/core/Popover';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import moment from 'moment-timezone'
import 'moment/locale/es'
import { Card, CardContent } from '@material-ui/core';
import { withTranslation } from 'react-i18next';
moment.locale('es')

class BaseElements extends Component {
    constructor(props) {
        super(props);
        var nodes=(props.location.state.fromObjective.Nodos)
        var listNodes=[]                                                                                            
        nodes.map(node=>{
            if(node["nodo"]!=='Global'){
                listNodes.push(node)
            }
        })
        const t = (this.props && this.props.t) ? this.props.t : (s => s);
        var statePeriod={}
        var endDate=(moment().tz(sessionStorage.getItem('tz')).format("YYYY-MM-DD hh:mm:ss"))
        var startDate=(moment().tz(sessionStorage.getItem('tz')).subtract(1,'day').format("YYYY-MM-DD hh:mm:ss"))
        statePeriod={startDate: startDate,endDate: endDate,key: "selection"}
        var monitores=(props.location.state.fromObjective.Monitores)
        this.myCallback = this.myCallback.bind(this);
        this.handlePeriodClick = this.handlePeriodClick.bind(this);
        this.state = {
            objetive: this.props.match.params.objetivo_id,
            isStatePeriod: false,
            settingsEl: null,
            steps:this.props.location.state.fromObjective.Pasos,
            isRefresh: false,
            isInfo: null,
            nodes:listNodes,
            listMonitores:monitores,
            errors:["",
                t("base-elements-plus.errors.only-one-day"),
                t("base-elements-plus.errors.dates-not-equal"),
                t("base-elements-plus.errors.start-date-greater"), 
                t("base-elements-plus.errors.end-date-exceeds"),
                t("base-elements-plus.errors.range-one-hour")
            ],
            indexError:0,
            buttonBoolean:true,
            isLoad:false,
            dateMoment:moment().tz(sessionStorage.getItem('tz')),
            dateBefore:moment().tz(sessionStorage.getItem('tz')).subtract({'hours': 1}),
            limit:new Date(new Date().setDate(new Date().getDate() - 6)),
            limit2:moment().tz(sessionStorage.getItem('tz'))._d,
            clockBegin:moment().tz(sessionStorage.getItem('tz')).subtract({'hours': 1})._d,
            clockFinal:moment().tz(sessionStorage.getItem('tz'))._d,
            open:false,
            isLoadButton:false,
            period: 'h',
            namePeriod: `${t('text.range')}: ${t('period.text.last-hour')}`,
            isStatePeriod: false,
            periodEl: null,
            namePeriodPorlet: [t('period.text.last-hour'), t('period.text.last-day'), t('period.text.last-week'), t('period.text.custom'), t('period.text.last-3-hours'), t('period.text.last-3-days'), t('period.text.last-6-hours'), t('period.text.last-12-hours')],
            typePeriod: 0,
            isOneHour: true,
            statePeriod: statePeriod,
            periodical: false,
        };
    }
    myCallback = (dataFromChild) => {
        this.setState({
            isLoadButton:false,
        })
    }

    componentDidUpdate(prevProps, prevState) {
        //console.log(prevState.buttonBoolean, this.state.buttonBoolean)
        if(prevState.buttonBoolean!== this.state.buttonBoolean){
            this.getData()
        }
    }
    getData=()=>{
        this.setState({
            isLoad:false,
            isLoadButton:false,
        })
    }
    handlePeriodClick(prevPeriod, prevTypeGraph, statePeriod, nextPeriod) {
        const t = (this.props && this.props.t) ? this.props.t : (s => s);
        if (nextPeriod === 'hora') {
            //var endDate=(moment().tz(sessionStorage.getItem('tz')).format("YYYY-MM-DD HH:mm:ss"))
            //var startDate=(moment().tz(sessionStorage.getItem('tz')).subtract(1,'hour').format("YYYY-MM-DD HH:mm:ss"))
            var dateMoment = moment().tz(sessionStorage.getItem('tz'))
            var dateBefore = moment().tz(sessionStorage.getItem('tz')).subtract({'hours': 1})
            //statePeriod={startDate: startDate,endDate: endDate,key: "selection"}
            this.setState({
                //typeGraph: prevTypeGraph,
                period: 'h',
                typePeriod: 0,
                namePeriod: `${t('text.range')}: ${t('period.text.last-hour')}`,
                //statePeriod: statePeriod,
                isStatePeriod: false,
                periodEl: null,
                isRefresh: false,
                dateBefore: dateBefore,
                dateMoment: dateMoment,
            });
        } else if (nextPeriod === '3hora') {
            //var endDate=(moment().tz(sessionStorage.getItem('tz')).format("YYYY-MM-DD HH:mm:ss"))
            //var startDate=(moment().tz(sessionStorage.getItem('tz')).subtract(3,'hour').format("YYYY-MM-DD HH:mm:ss"))
            var dateMoment = moment().tz(sessionStorage.getItem('tz'))
            var dateBefore = moment().tz(sessionStorage.getItem('tz')).subtract({'hours': 3})
            //statePeriod={startDate: startDate,endDate: endDate,key: "selection"}
            this.setState({
                //typeGraph: prevTypeGraph,
                period: '3h',
                typePeriod: 4,
                namePeriod: `${t('text.range')}: ${t('period.text.last-3-hours')}`,
                //statePeriod: statePeriod,
                isStatePeriod: false,
                periodEl: null,
                isRefresh: false,
                dateBefore: dateBefore,
                dateMoment: dateMoment,
            });
        }else if (nextPeriod === '6hora') {
            //var endDate=(moment().tz(sessionStorage.getItem('tz')).format("YYYY-MM-DD HH:mm:ss"))
            //var startDate=(moment().tz(sessionStorage.getItem('tz')).subtract(6,'hour').format("YYYY-MM-DD HH:mm:ss"))
            //statePeriod={startDate: startDate,endDate: endDate,key: "selection"}
            var dateMoment = moment().tz(sessionStorage.getItem('tz'))
            var dateBefore = moment().tz(sessionStorage.getItem('tz')).subtract({'hours': 6})
            this.setState({
                //typeGraph: prevTypeGraph,
                period: '6h',
                typePeriod: 6,
                namePeriod: `${t('text.range')}: ${t('period.text.last-6-hours')}`,
                statePeriod: statePeriod,
                isStatePeriod: false,
                periodEl: null,
                isRefresh: false,
                dateBefore: dateBefore,
                dateMoment: dateMoment,
            });
        }else if (nextPeriod === '12hora') {
            //var endDate=(moment().tz(sessionStorage.getItem('tz')).format("YYYY-MM-DD HH:mm:ss"))
            //var startDate=(moment().tz(sessionStorage.getItem('tz')).subtract(12,'hour').format("YYYY-MM-DD HH:mm:ss"))
            //statePeriod={startDate: startDate,endDate: endDate,key: "selection"}
            var dateMoment = moment().tz(sessionStorage.getItem('tz'))
            var dateBefore = moment().tz(sessionStorage.getItem('tz')).subtract({'hours': 12})
            this.setState({
                //typeGraph: prevTypeGraph,
                period: '12h',
                typePeriod: 7,
                namePeriod: `${t('text.range')}: ${t('period.text.last-12-hours')}`,
                statePeriod: statePeriod,
                isStatePeriod: false,
                periodEl: null,
                isRefresh: false,
                dateBefore: dateBefore,
                dateMoment: dateMoment,
            });
        } else if (nextPeriod === 'dia') {
            //var endDate=(moment().tz(sessionStorage.getItem('tz')).format("YYYY-MM-DD HH:mm:ss"))
            //var startDate=(moment().tz(sessionStorage.getItem('tz')).subtract(1,'day').format("YYYY-MM-DD HH:mm:ss"))
            //statePeriod={startDate: startDate,endDate: endDate,key: "selection"}
            var dateMoment = moment().tz(sessionStorage.getItem('tz'))
            var dateBefore = moment().tz(sessionStorage.getItem('tz')).subtract({'hours': 24})
            this.setState({
                //typeGraph: prevTypeGraph,
                period: "d",
                typePeriod: 1,
                namePeriod: `${t('text.range')}: ${t('period.text.last-day')}`,
                statePeriod: statePeriod,
                isStatePeriod: false,
                periodEl: null,
                isRefresh: false,
                dateBefore: dateBefore,
                dateMoment: dateMoment,
            });
        } /*else if (nextPeriod === '3dia') {
            var endDate=(moment().tz(sessionStorage.getItem('tz')).format("YYYY-MM-DD HH:mm:ss"))
            var startDate=(moment().tz(sessionStorage.getItem('tz')).subtract(3,'day').format("YYYY-MM-DD HH:mm:ss"))
            statePeriod={startDate: startDate,endDate: endDate,key: "selection"}
            this.setState({
                //typeGraph: prevTypeGraph,
                period: "3d",
                typePeriod: 5,
                namePeriod: 'Rango: últimos 3 días',
                statePeriod: statePeriod,
                isStatePeriod: false,
                periodEl: null,
                isRefresh: false,
                begin: startDate,
                end: endDate,
            });
        } else if (nextPeriod === 'semana') {
            var endDate=(moment().tz(sessionStorage.getItem('tz')).format("YYYY-MM-DD HH:mm:ss"))
            var startDate=(moment().tz(sessionStorage.getItem('tz')).subtract(1,'week').format("YYYY-MM-DD HH:mm:ss"))
            statePeriod={startDate: startDate,endDate: endDate,key: "selection"}
            this.setState({
                //typeGraph: prevTypeGraph,
                period: "w",
                typePeriod: 2,
                namePeriod: 'Rango: última semana',
                statePeriod: statePeriod,
                isStatePeriod: false,
                periodEl: null,
                isRefresh: false,
                begin: startDate,
                end: endDate,
            });
        }*/ else if (nextPeriod === 'custom') {
            //var startDate = moment(statePeriod).format("YYYY-MM-DD HH:mm:ss")
            //var endDate = moment(statePeriod).add('days', 1).format("YYYY-MM-DD HH:mm:ss")
            //statePeriod = {startDate: startDate, endDate: endDate, key: "selection"}
            var dateMoment = moment(statePeriod).add('days', 1)
            var dateBefore = moment(statePeriod)
            this.setState({
                //typeGraph: prevTypeGraph,
                period: "c",
                typePeriod: 3,
                namePeriod: `${t('text.range')}: ${dateBefore.format("YYYY-MM-DD HH:mm:ss").substring(0, 10)} ${t('text.to2')} ${dateMoment.format("YYYY-MM-DD HH:mm:ss").substring(0, 10)}`,
                statePeriod: statePeriod,
                isStatePeriod: true,
                periodEl: null,
                isRefresh: false,
                dateBefore: dateBefore,
                dateMoment: dateMoment,
            });
        }
        //this.getDataFromAPI();
    }

    handleShowPeriod = event => {
        this.setState({
            periodEl: event.currentTarget
        });
    };

    handleClosePeriod = () => {
        this.setState({
            periodEl: null
        });
    };
    
    
    handleClose = event => {
        //console.log('fsd')
        this.props.onClose()
    };

    render() {        
        const {nodes, steps, objetive, dateMoment, dateBefore, isLoad,
            namePeriod, namePeriodPorlet, typePeriod, periodEl, typeGraph, isOneHour, statePeriod, period, periodical} = this.state;
        const showPeriodEl = Boolean(periodEl);
        const t = (this.props && this.props.t) ? this.props.t : (s => s);
        if (isLoad==true) {
            return(
                <div>
    
                    <Typography
                        variant="caption"
                    >
                        <CircularProgress
                        variant="indeterminate"

                        size={12}
                        thickness={3}
                        
                    />
                        {t('text.loading')}
                    </Typography>
                </div>
            )
        }else{
            return (
                <Card style={{overflowY: 'auto'}}>
                    <PortletHeader>
                        <PortletToolbar style={{width:"100%"}}>
                            <Grid
                                container direction="row" justify="center" alignItems="flex-end" spacing={1}
                            >
                                <Grid
                                    item
                                    xs={6}
                                    md={6}
                                    xl={6}
                                >
                                    <Typography variant="h4" className='card__text--dark-color'>{t('elements-plus.modal.title')}</Typography>
                                    <Typography variant='subtitle2' className='card__text--dark-color'>{namePeriod}</Typography>
                                </Grid>
                                <Grid
                                    item
                                    xs={5}
                                    md={5}
                                    xl={5}
                                >
                                    <Button  style={{fontSize:'14px',float:'right'}} onClick={this.handleShowPeriod}>
                                        {namePeriodPorlet[typePeriod]}<ArrowDropDownIcon />
                                    </Button>
                                    <Popover
                                        anchorEl={periodEl}
                                        anchorOrigin={{
                                            vertical: 'bottom',
                                            horizontal: 'center'
                                        }}
                                        onClose={this.handleClosePeriod}
                                        open={showPeriodEl}
                                        transformOrigin={{
                                            vertical: 'top',
                                            horizontal: 'center'
                                        }}>
                                            <Period onClick={this.handlePeriodClick} range={statePeriod} period={period} periodical={periodical} typeGraph={typeGraph} isOneHour={isOneHour}/>
                                    </Popover>
                                </Grid>
                                <Grid
                                    item
                                    xs={1}
                                    md={1}
                                    xl={1}
                                    style={{textAlign:'right'}}
                                >
                                    <IconButton key="close" aria-label="close" onClick={this.handleClose}><CloseIcon/></IconButton>
                                </Grid>
                            </Grid>
                        </PortletToolbar>
                    </PortletHeader>
                    <CardContent>
                        <BaseDataElements callbackFromParent={this.myCallback} nodes={nodes} objective={objetive} steps={steps} dateBegin={dateBefore} dateFinal={dateMoment}/>
                    </CardContent>
                </Card>
            )
        
        }

        
    }
}


export default
    compose(withRouter, withStyles(styles), withTranslation())(BaseElements);